/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
import { Divider } from 'antd';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Typography } from 'tfc-components';

import Container from '../Container';

import logoEvol from 'assets/images/logo_evol.png';
import Icon, { IconName } from 'components/atoms/Icon';
import Image from 'components/atoms/Image';

interface ISocial {
  name: IconName;
  link?: string;
  id: number;
}
// data social
const dataSocial: ISocial[] = [
  { name: 'facebookOrange', link: 'https://www.facebook.com/evollabs/', id: 1 },
  // { name: 'googleOrange', link: '', id: 2 },
  { name: 'linkedinOrange', link: 'https://www.linkedin.com/company/evol-labs/', id: 2 },
  { name: 'youtubeOrange', link: 'https://www.youtube.com/@EVOLASKLY', id: 3 },
  // { name: 'githubOrange', link: '', id: 5 },
  // { name: 'slackOrange', link: '', id: 6 },
];
const pathName = window.location.pathname;
const FooterWeb: React.FC = () => (
  <footer className="o-footerWeb">
    <Container>
      <div className="o-footerWeb_left">
        <NavLink to="/">
          <div className="o-footerWeb_logo">
            <Image
              ratio="205x42"
              src={logoEvol}
              alt="Logo Evol"
              size="contain"
              className="t-login_logo"
            />
          </div>
        </NavLink>
        <div className="o-footerWeb_description">
          {
            pathName === '/blog/hanh-chinh-cong' ? (
              <>
                <Typography.Heading type="h4" extendClasses="o-footerWeb_description_title" fontweight="600">
                  MOBIFONE TÂY NINH
                </Typography.Heading>

                <Typography.Text extendClasses="o-footerWeb_description_info" fontweight="400">
                  <span className="o-footerWeb_description_label">Địa chỉ:</span>
                  {' '}
                  Đường Hùng Vương, Phường Long An, Tỉnh Tây Ninh
                </Typography.Text>
                <Typography.Text extendClasses="o-footerWeb_description_info" fontweight="400">
                  <span className="o-footerWeb_description_label">Hotline:</span>
                  {' '}
                  079 718 7070
                </Typography.Text>

              </>
            )

              : (
                <>
                  <Typography.Heading type="h4" extendClasses="o-footerWeb_description_title" fontweight="600">
                    EVOL LABS Company Limited (EVOL LABS)
                  </Typography.Heading>
                  <Divider className="o-footerWeb_description_divider" />
                  <Typography.Text extendClasses="o-footerWeb_description_info" fontweight="600">Contact</Typography.Text>
                  <Typography.Text extendClasses="o-footerWeb_description_info" fontweight="400">
                    <span className="o-footerWeb_description_label">Head Office:</span>
                    {' '}
                    1st Floor, 207A Nguyen Van Thu Street, Da Kao Ward, District 1, Ho Chi Minh City, Vietnam
                  </Typography.Text>
                  <Typography.Text extendClasses="o-footerWeb_description_info" fontweight="400">
                    <span className="o-footerWeb_description_label">Business Registration Certificate No.:</span>
                    {' '}
                    0318926829 – First issued on: April 23, 2025 – Issued by: Business Registration Office – Department of Finance, Ho Chi Minh City
                  </Typography.Text>
                  <Typography.Text extendClasses="o-footerWeb_description_info" fontweight="400">
                    <span className="o-footerWeb_description_label">Email:</span>
                    {' '}
                    <a href="mailto:info@evollabs.vn">info@evollabs.vn</a>
                  </Typography.Text>
                  <Typography.Text extendClasses="o-footerWeb_description_info" fontweight="400">
                    <span className="o-footerWeb_description_label">Hotline:</span>
                    {' '}
                    <a href="tel:0946111594">0946111594</a>
                  </Typography.Text>
                </>
              )
          }

        </div>
        {
          pathName !== '/blog/hanh-chinh-cong' && (
            <>
              <div className="o-footerWeb_social">
                {dataSocial.map((item) => (
                  <a href={`${item?.link}` || '#'} key={item.id} target="_blank" className="o-footerWeb_social_item" rel="noreferrer">
                    <Icon iconName={item.name} size="18" />
                  </a>
                ))}
              </div>
              <Typography.Text extendClasses="o-footerWeb_copyright">Copyright © by Evol Labs</Typography.Text>
            </>
          )
        }
      </div>
      <div className="o-footerWeb_nav">
        <Container>
          {/* <a href="https://evollabs.vn/" target="_blank" className="o-footerWeb_nav_item" rel="noreferrer">
            Về EVOL LABS
          </a> */}
          <div className="o-footerWeb_nav_item">
            <Typography.Heading type="h4" fontweight="600" extendClasses="o-footerWeb_nav_itemTitle f-20x24">About us</Typography.Heading>
            <NavLink className="o-footerWeb_nav_itemLink f-16x18" to="/privacy-policy">
              Privacy Policy
            </NavLink>
            <NavLink className="o-footerWeb_nav_itemLink f-16x18" to="/terms-and-conditions">
              Terms and conditions
            </NavLink>
          </div>
        </Container>
      </div>
    </Container>
  </footer>
);

export default FooterWeb;
